import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { clinicsApi } from '../../services/clinicsService'
import type { Clinic } from '../../types/api'

// Async thunks
export const fetchClinics = createAsyncThunk(
  'clinics/fetchClinics',
  async () => {
    const response = await clinicsApi.getClinics()
    return response
  }
)

// State interface
interface ClinicsState {
  clinics: Clinic[]
  loading: boolean
  error: string | null
}

// Initial state
const initialState: ClinicsState = {
  clinics: [],
  loading: false,
  error: null,
}

// Slice
const clinicsSlice = createSlice({
  name: 'clinics',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    // Fetch clinics
    builder
      .addCase(fetchClinics.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchClinics.fulfilled, (state, action) => {
        state.loading = false
        state.clinics = action.payload
      })
      .addCase(fetchClinics.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to fetch clinics'
      })
  },
})

// Export actions
export const { clearError } = clinicsSlice.actions

// Selectors
export const selectClinics = (state: { clinics: ClinicsState }) => state.clinics.clinics
export const selectClinicsLoading = (state: { clinics: ClinicsState }) => state.clinics.loading
export const selectClinicsError = (state: { clinics: ClinicsState }) => state.clinics.error

export default clinicsSlice.reducer